import { DynamicFormRequiredType, type DynamicFormSettings } from '@myosh/odin-components';
import type { LinkTargetType } from '../../../../@types/forms';
import i18next from '../../../../i18n';
import type { FormBuilderField } from '../../../../redux/slices/form-builder-slice';

export const targetOptions: Array<{ text: string; value: LinkTargetType }> = [
  { text: i18next.t('current-window-tab'), value: 'CURRENT' },
  { text: i18next.t('new-window-tab'), value: 'NEW' },
];

export const linkFieldFormSettings: DynamicFormSettings = {
  id: 'LinkFieldSettingsGroup',
  caption: i18next.t('target'),
  fields: [
    {
      id: 'target',
      fieldType: 'OPTIONGROUP',
      fieldName: 'target',
      caption: i18next.t('target'),
      required: DynamicFormRequiredType.True,
      permissions: { edit: true, read: true },
      dynamicProperties: {
        data: targetOptions,
        textField: 'text',
        valueField: 'value',
        target: targetOptions[0].value,
        required: DynamicFormRequiredType.True,
      },
      position: 40,
    },
  ],
};

export const getLinkFieldValues = (field: FormBuilderField) => {
  const selectedValue = field.target;
  const targetValue = targetOptions.find((option) => option.value === selectedValue) ?? targetOptions[0];
  return {
    target: targetValue,
  };
};
